import { render, staticRenderFns } from "./PromotionListModal.vue?vue&type=template&id=d2f9c20e&"
import script from "./PromotionListModal.vue?vue&type=script&lang=js&"
export * from "./PromotionListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports